import styled, { css } from 'styled-components';
import { down } from 'styled-breakpoints';

export const HeaderContainer = styled.header`
  ${({ theme }) => css`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: ${theme.layout.header};
    background: ${theme.colors.background[100]};
    border-bottom: 1px solid ${theme.colors.background[40]};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 1.5rem;
    z-index: 30;

    ${down('lg')} {
      padding: 0 1rem;
    }
  `}
`;

export const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

export const LogoIcon = styled.div`
  ${({ theme }) => css`
    width: 2rem;
    height: 2rem;
    border-radius: ${theme.radii.default};
    background: linear-gradient(
      135deg,
      ${theme.colors.gradients.primary[0]},
      ${theme.colors.gradients.primary[100]}
    );
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: 700;
    font-size: ${theme.fontSizes.sm};
  `}
`;

export const LogoImage = styled.img`
  max-height: 2.75rem;
  object-fit: contain;
`;

export const EventName = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.md};
    font-weight: 600;
    color: ${theme.colors.foreground[80]};

    ${down('md')} {
      display: none;
    }
  `}
`;

export const EventTagline = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.sm};
    color: ${theme.colors.foreground[40]};
    margin-left: 0.5rem;

    ${down('xl')} {
      display: none;
    }
  `}
`;

export const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const MobileMenuButton = styled.button`
  ${({ theme }) => css`
    display: none;
    width: 2.5rem;
    height: 2.5rem;
    align-items: center;
    justify-content: center;
    border: none;
    border-radius: ${theme.radii.default};
    background: transparent;
    color: ${theme.colors.foreground[60]};
    cursor: pointer;
    transition: all ${theme.transition.default};

    &:hover {
      background: ${theme.colors.background[60]};
      color: ${theme.colors.foreground[80]};
    }

    ${down('lg')} {
      display: flex;
    }
  `}
`;

export const UserButton = styled.button`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.375rem 0.75rem 0.375rem 0.375rem;
    border: none;
    border-radius: ${theme.radii.full};
    background: ${theme.colors.background[60]};
    cursor: pointer;
    transition: all ${theme.transition.default};

    &:hover {
      background: ${theme.colors.background[40]};
    }

    ${down('md')} {
      padding: 0.25rem;
      background: transparent;

      &:hover {
        background: transparent;
      }
    }
  `}
`;

export const UserName = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.sm};
    font-weight: 500;
    color: ${theme.colors.foreground[80]};

    ${down('md')} {
      display: none;
    }
  `}
`;

export const IndicationsButton = styled.button`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.25rem;
    height: 2.25rem;
    border: none;
    border-radius: 0.5rem;
    background: transparent;
    cursor: pointer;
    transition: all ${theme.transition.default};

    &:hover {
      background: ${theme.colors.background[60]};
    }

    svg {
      width: 1.25rem;
      height: 1.25rem;
    }
  `}
`;
